import React from "react";
import "./banner.css";
import { Link } from "react-router-dom";
import banner1 from "../assets/images/slider-1.jpg";

const Banner = () => {
  return (
    <section
      className="fintech-banner"
      style={{ backgroundImage: `url(${banner1})` }}
    >
      <div className="banner-overlay"></div>

      <div className="banner-inner">
        <div className="banner-text">
          <h5 className="sub-heading">Empowering Digital Finance</h5>
          <h1 className="main-heading">
            Smarter <span className="highlight">Solutions</span> for a Connected Future
          </h1>
          <p className="description">
            Experience secure, seamless, and fast financial technology. 
            From instant loan management to digital payment innovation — we make finance smarter.
          </p>
        </div>

        <div className="banner-stats">
          <div className="stat">
            <h3>95%</h3>
            <p>Customer Satisfaction</p>
          </div>
          <div className="stat">
  <h3>5000+</h3>
  <p>Happy Clients</p>
</div>
        <div className="stat">
  <h3>100%</h3>
  <p>Secure Process</p>
</div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
